// Daily sales ("Mis Ventas") stored in localStorage as { "YYYY-MM-DD": amount }.
// Deliberately tiny: just today's number, last 7 days, month total, best day.

const VENTAS_KEY = "negoia:ventas";
const META_KEY = "negoia:meta_diaria";
const RATING_KEY = "negoia:ventas_rating";

export function getRatingHoy() {
  try {
    const r = JSON.parse(localStorage.getItem(RATING_KEY) || "{}")[todayKey()];
    return typeof r === "string" ? r : null;
  } catch {
    return null;
  }
}

export function saveRatingHoy(rating) {
  try {
    const all = JSON.parse(localStorage.getItem(RATING_KEY) || "{}");
    all[todayKey()] = rating;
    localStorage.setItem(RATING_KEY, JSON.stringify(all));
  } catch {
    /* private mode — won't persist */
  }
}

export function getMeta() {
  try {
    const v = Number(localStorage.getItem(META_KEY));
    return Number.isFinite(v) && v > 0 ? v : 0;
  } catch {
    return 0;
  }
}

export function saveMeta(amount) {
  try {
    if (amount > 0) localStorage.setItem(META_KEY, String(amount));
    else localStorage.removeItem(META_KEY);
  } catch {
    /* private mode — won't persist */
  }
}

function todayKey(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function readVentas() {
  try {
    const raw = localStorage.getItem(VENTAS_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function getVentaHoy() {
  const v = readVentas()[todayKey()];
  return typeof v === "number" ? v : null;
}

export function saveVentaHoy(amount) {
  const ventas = readVentas();
  ventas[todayKey()] = amount;
  try {
    localStorage.setItem(VENTAS_KEY, JSON.stringify(ventas));
  } catch {
    /* private mode — won't persist */
  }
  return ventas;
}

// Last 7 days (oldest → today) as [{ key, label, amount }].
export function getLast7Days() {
  const ventas = readVentas();
  const days = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
  const out = [];
  for (let i = 6; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const key = todayKey(d);
    out.push({
      key,
      label: days[d.getDay()],
      amount: typeof ventas[key] === "number" ? ventas[key] : 0,
    });
  }
  return out;
}

// Sum of the current calendar month.
export function getMonthTotal() {
  const ventas = readVentas();
  const now = new Date();
  const prefix = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-`;
  return Object.entries(ventas).reduce(
    (sum, [k, v]) => (k.startsWith(prefix) && typeof v === "number" ? sum + v : sum),
    0,
  );
}

// Highest single-day amount in the current calendar month (0 if none).
export function getBestDayThisMonth() {
  const ventas = readVentas();
  const now = new Date();
  const prefix = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-`;
  let best = 0;
  Object.entries(ventas).forEach(([k, v]) => {
    if (k.startsWith(prefix) && typeof v === "number" && v > best) best = v;
  });
  return best;
}
